import React, { Component } from 'react';
import './HouseTypesViewer.css';
import GenericWindow from '../window/GenericWindow';
import IconButtonNonReact from '../components/IconButtonNonReact';
import AssetsManager from '../assets_management/AssetsManager';
import Urls from '../urls/Urls';
import WindowType from '../enums/WindowType';
import HouseTypesViewerEntry from './HouseTypesViewerEntry';
import MenuType from '../enums/MenuType';
import ResizeWatchers from '../ui_core/ResizeWatchers';
export default class HouseTypesViewer {
	constructor(props){
		const {onSelectedOptionsChange, clearFilters, showMenu, showImagesFullScreen, showStreetView, 
		addFavourite, removeFavourite, enterHouse, configuration} = props;
		this._configuration= configuration;
		this._showImagesFullScreen=showImagesFullScreen;
		this._showStreetView = showStreetView;
		this._updateSelected= this._updateSelected.bind(this);
		this._callbackAddFavourite = addFavourite;
		this._callbackRemoveFavourite = removeFavourite;
		this._callbackSelectedOptionsChange=onSelectedOptionsChange;
		this._enterHouse = enterHouse;
		this._mapHouseTypeToEntry = new Map();
		
		const title = "Select House type(s)"
		this._window = new GenericWindow({tooltipMessage:title, name:title, minWidth:280, maxWidth:800, minHeight:100, maxHeight:1000,
			defaultWidth:configuration.hideHouseTypeDescriptionOnHouseTypesMenu?340:600, defaultHeight:600, defaultX:10, defaultY:10, minimized:!
			configuration.showHouseTypesViewerOnOpen, 
			maximized:configuration.showHouseTypesViewerOnOpen, minimizable:true,
			maximizable:true, closeable:true, minimizeOnClose:true, resizable:true, dragable:true,
			type:WindowType.HOUSE_TYPE_VIEWER
		});
		this._element = this._window.getElement();
		this._element.classList.add('house-types-viewer');
		this._innerElement =this._window.getMainElement();
		this._innerElement.classList.add('inner');
		this.initialize = this.initialize.bind(this);
		this._createEntries = this._createEntries.bind(this);
		this._clickedEntry = this._clickedEntry.bind(this);
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this._handleResized = this._handleResized.bind(this);
		ResizeWatchers.add({element:this._element, onResized:this._handleResized,staggered:false});
		
		
		this._entries = [];
		this._scrollableElement = document.createElement('div');
		this._scrollableElement.classList.add('scrollable');
		
		if(!configuration.hideFilteringIconsFromPlotAndHouseTypeMenu){
			this._menuElement= document.createElement('div');
			this._menuElement.classList.add('top-menu');
			this._iconButtonMenu = new IconButtonNonReact({ 	
					className:"button-menu", 
					imgUrl:Urls.assets+'icons/UI_Button_Filter.png',
					onClick:showMenu
			});
			this._menuElement.appendChild(this._iconButtonMenu.element);
			this._iconButtonClearFilters = new IconButtonNonReact({ 	
					className:"button-clear-filters", 
					imgUrl:Urls.assets+'icons/UI_Button_Filter_Clear.png',
					onClick:clearFilters
			});
			this._menuElement.appendChild(this._iconButtonClearFilters.element);
			this._innerElement.appendChild(this._menuElement);
		}
		this._innerElement.appendChild(this._scrollableElement);
	}
	initialize({siteJson, houseTypesViewModel}){
		this._siteJson = siteJson;
		const title = siteJson.allUnitsHaveMultiplePlots?"Apartment Type":"House type";
		this._window.setName(title);
		this._window.setTooltipMessage(title);
		this._createEntries(houseTypesViewModel);
	}
	_handleResized(){
		if(this._element.offsetWidth<440)
			this._element.classList.add('small-width');
		else
			this._element.classList.remove('small-width')
	}
	_updateSelected(){
		const houseTypeListsSelected = this._getHouseTypeListsSelected();
		const seenEntries =[];
		houseTypeListsSelected.forEach(houseTypeListSelected=>{
			const firstHouseTypeWithName = houseTypeListSelected[0];
			const entry = this._mapHouseTypeToEntry.get(firstHouseTypeWithName);
			seenEntries.push(entry);
			entry.houseTypeSelected = true;
		});
		const entriesNotSeen = this._entries.filter(entry=>seenEntries.indexOf(entry)<0);
		entriesNotSeen.forEach(entryNotSeen=>entryNotSeen.houseTypeSelected=false);
	}
	_createEntries(houseTypesViewModel){
		houseTypesViewModel.entries.forEach(houseTypeViewModel=>{
			const houseTypes =houseTypeViewModel.houseTypesWithSameName;
			let allHouseTypePlots = [];
			houseTypes.forEach(houseType=>allHouseTypePlots = allHouseTypePlots.concat(houseType.plots));
			if(allHouseTypePlots.length<1)return;
			const houseTypesViewerEntry = new HouseTypesViewerEntry({
				houseTypes,
				callbackClicked:this._clickedEntry,
				houseTypeViewModel,
				showImagesFullScreen:this._showImagesFullScreen,
				showStreetView:this._showStreetView,
				hide:this.hide,
				callbackAddFavourite:this._callbackAddFavourite,
				callbackRemoveFavourite:this._callbackRemoveFavourite,
				enterHouse:this._enterHouse,
				configuration:this._configuration
			});
			this._entries.push(houseTypesViewerEntry);
			houseTypes.forEach(houseType=>
				this._mapHouseTypeToEntry.set(houseType, houseTypesViewerEntry)
			);
			this._scrollableElement.appendChild(houseTypesViewerEntry.element);
		});
	}
	_clickedEntry(entry){
		
	}
	show(){
		this._window.unminimize();
		this._window.bringToFront();
		this._handleResized()
	}
	hide(){
		this._window.minimize();
	}
	get element(){
		return this._element;
	}
}
